import { render, staticRenderFns } from "./CadastroConsulta.vue?vue&type=template&id=b01ba186&scoped=true&"
import script from "./CadastroConsulta.vue?vue&type=script&lang=js&"
export * from "./CadastroConsulta.vue?vue&type=script&lang=js&"
import style0 from "./CadastroConsulta.vue?vue&type=style&index=0&id=b01ba186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01ba186",
  null
  
)

export default component.exports